<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h2>開発者用画面</h2>
      </div>
      <div class="col-md-12">
        <ul>
          <li>
            <router-link :to="{name: 'DevDebugUIShowcase'}" class="nav-link">
              UI Show Case
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.nav-link {
  padding: 8px 0;
}
</style>
